/* Custom  */
document.addEventListener('DOMContentLoaded', function () {
  var readMoreLink = document.getElementById('read-more-description');

  if (readMoreLink) {
    readMoreLink.addEventListener('click', function (event) {
      event.preventDefault();

      var specificDetails = document.getElementById('my-specific-details');
      if (specificDetails) {
        specificDetails.open = !specificDetails.open;
        specificDetails.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});
